/**
 * Determines whether a `next` redirect target is safe to honor after login.
 *
 * Safe targets must:
 *   - Be a string
 *   - Start with "/" (relative-from-root paths only)
 *   - Not start with "//" (which would be protocol-relative and could
 *     point to a different origin)
 *   - Match the URL surface of the role being authenticated:
 *       - employer login can only bounce to /employers/* paths
 *       - seeker login can only bounce to non-employer paths
 *
 * This guards against cross-role redirect attacks where an attacker-supplied
 * `next` parameter on one role's login URL would bounce the authenticated
 * user to the other role's surface.
 *
 * @param {string|null|undefined} nextUrl - The candidate redirect target.
 * @param {"seeker"|"employer"} role - The role being authenticated.
 * @returns {boolean} true if the target is safe to redirect to.
 */
export function isSafeNext(nextUrl, role) {
  if (typeof nextUrl !== "string") return false;
  if (!nextUrl.startsWith("/")) return false;
  if (nextUrl.startsWith("//")) return false;
  if (role === "employer" && !nextUrl.startsWith("/employers")) return false;
  if (role === "seeker" && nextUrl.startsWith("/employers")) return false;
  return true;
}
